"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ExperimentDescription = function ExperimentDescription(_ref) {
  var outProxy = _ref.outProxy,
      experimentUrl = _ref.experimentUrl,
      description = _ref.description;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: "1rem",
      clear: "both",
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
    target: "_blank",
    href: outProxy + experimentUrl
  }, description)));
};

ExperimentDescription.propTypes = {
  outProxy: _propTypes["default"].string.isRequired,
  experimentUrl: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string.isRequired
};
var _default = ExperimentDescription;
exports["default"] = _default;